<template>
  <div id="pnr-detail">
    <div class="pnr-error">
      <a-textarea :rows="10" v-model="pnrData.originalRT" />
    </div>
    <div class="pnr-error-text" v-if="pnrData.warns">
      <p>注意：您的PNR存在以下问题，将导致无法入库！</p>
      <div class="pnr-error-item">
        <p v-for="(item, index) in pnrData.warns" :key="index">{{item}}</p>
      </div>
    </div>
    <div class="pnr-table">
      <div class="table-segments">
        <a-table
          :columns="columns1"
          :dataSource="segmentsData"
          :rowKey="record => record.index"
          :pagination="false"
        ></a-table>
      </div>
      <div class="table-passengers">
        <a-table
          :columns="columns2"
          :dataSource="passengersData"
          :childrenColumnName="'accompanyingPassengers'"
          :defaultExpandAllRows="true"
          :rowKey="record => record.certNo"
          :pagination="false"
        >
          <template slot="name" slot-scope="text, record">
            <span v-if="record.passengerType == 'INFANT'">携带婴儿姓名：{{text}}</span>
            <span v-else>{{text}}</span>
          </template>
          <template slot="passengerTypeText" slot-scope="text, record">
            <span v-if="record.passengerType == 'INFANT'"></span>
            <span v-else>{{text}}</span>
          </template>
          <template slot="certType" slot-scope="text, record">
            <span v-if="record.passengerType == 'INFANT'">出生日期：{{record.birthdayText}}</span>
            <span v-else>{{text}}</span>
          </template>
          <template slot="certNo" slot-scope="text, record">
            <div>
              <a-input
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record.key)"
              />
              <template v-else>{{text}}</template>
            </div>
          </template>
          <template slot="action" slot-scope="text, record">
            <div class="editable-row-operations" v-if="record.passengerType != 'INFANT'">
              <span v-if="record.editable">
                <a @click="() => save(record.key)">保存</a>
                <a-popconfirm title="是否确定取消修改？" @confirm="() => cancel(record.key)">
                  <a>取消</a>
                </a-popconfirm>
              </span>
              <span v-else>
                <a @click="() => edit(record.key)">修改</a>
              </span>
            </div>
          </template>
        </a-table>
      </div>
    </div>
    <div class="pnr-ticket-table" >
      <div class="table-fares">
        <h5>
          票价信息
          <span>货币类型：人民币(CNY)</span>
        </h5>
        <div v-for="(item,index) in pnrData.segmentFares" :key="index" :style="{'margin-top': index > 0 ? '15px' : ''}">
          <template v-if="pnrData.tripType === 'OW'">
            <h5 >请选择行程({{item.segment.depCode}} - {{item.segment.arrCode}})票价</h5>
          </template>
          <template v-if="pnrData.tripType === 'MW'">
            <h5 v-show="index === 0">请选择去程({{item.segment.depCode}} - {{item.segment.arrCode}})票价</h5>
            <h5 v-show="index === 1">请选择返程({{item.segment.depCode}} - {{item.segment.arrCode}})票价</h5>
          </template>
          <template v-if="pnrData.tripType === 'RT'">
            <h5 >请选择第{{Number(index) + 1}}程({{item.segment.depCode}} - {{item.segment.arrCode}})票价</h5>
          </template>
          <pnr-detail-table :pnrData="pnrData" :item="item" :index="index" :defaultPrice="defaultPrice" ></pnr-detail-table>
        </div>
      </div>
      <div class="total-fare">
        <p>
          订单总价：
          <em>￥{{pnrData.totalFare}}元</em>
        </p>
      </div>
    </div>
    <div class="pnr-submit">
      <a-button type="primary" size="large" @click="handleSubmit" :loading="loading">提交</a-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import pnrDetailTable from './pnrDetailTable'
import { pnrSubmit } from '@/apis/agent'
import storage from '@/assets/js/storage'

const columns1 = [
  {
    title: '序号',
    dataIndex: 'index',
    className: 'table-col1',
    align: 'center'
  }, {
    title: '行程',
    dataIndex: 'airline',
    className: 'table-col2',
    align: 'center'
  }, {
    title: '航班号',
    dataIndex: 'flightNo',
    className: 'table-col2',
    align: 'center'
  }, {
    title: '起飞时间',
    dataIndex: 'depTimeFormat',
    className: 'table-col2',
    align: 'center'
  }, {
    title: '舱位',
    dataIndex: 'cabin',
    className: 'table-col2',
    align: 'center'
  }, {
    title: '行动代码',
    dataIndex: 'actionCode',
    className: 'table-col1',
    align: 'center'
  }
]
const columns2 = [
  {
    title: '序号',
    dataIndex: 'index',
    className: 'table-col1',
    align: 'center'
  }, {
    title: '姓名',
    dataIndex: 'name',
    className: 'table-col2',
    align: 'center',
    scopedSlots: { customRender: 'name' }
  }, {
    title: '旅客类型',
    dataIndex: 'passengerTypeText',
    className: 'table-col2',
    align: 'center',
    scopedSlots: { customRender: 'passengerTypeText' }
  }, {
    title: '证件类型',
    dataIndex: 'certType',
    className: 'table-col2',
    align: 'center',
    scopedSlots: { customRender: 'certType' }
  }, {
    title: '证件号码',
    dataIndex: 'certNo',
    className: 'table-col2',
    align: 'center',
    scopedSlots: { customRender: 'certNo' }
  }, {
    title: '操作',
    className: 'table-col1',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: {
    pnrDetailTable
  },
  props: {
    pnrData: Object
  },
  data () {
    return {
      columns1,
      columns2,
      segmentsData: [], // 航班信息
      cacheData: [],
      passengersData: [], // 乘客信息
      loading: false,
      defaultPrice: 0
    }
  },

  mounted () {
    const { pnrData } = this
    this.segmentsData = []
    if (pnrData.segments) {
      pnrData.segments.forEach((item, index) => {
        let row = item
        row.index = index + 1
        row.airline = item.depCode + '-' + item.arrCode
        let depTime = moment(row.depTime).format()
        let depDate = depTime.split('T')[0]
        let depHour = depTime.split('T')[1].split('+')[0].slice(0, 5)
        let timeFormat = depDate + ' ' + depHour
        row.depTimeFormat = timeFormat
        this.segmentsData.push(row)
      })
    }
    if (pnrData.passengers) {
      pnrData.passengers.forEach((item, index) => {
        let row = item
        row.index = index + 1
        row.key = index + 1
        let psgType = ''
        switch (item.passengerType) {
          case 'ADULT':
            psgType = '成人'
            break
          case 'CHILD':
            psgType = '儿童'
            break
          case 'INFANT':
            psgType = '婴儿'
            break
        }
        row.passengerTypeText = psgType
        if (row.accompanyingPassengers) {
          row.accompanyingPassengers.forEach((child, index) => {
            let birthday = child.birthday
            birthday = moment(birthday).format()
            birthday = birthday.split('T')[0]
            child.birthdayText = birthday
          })
        }
        this.passengersData.push(row)
        this.cacheData.push(row)
      })
    }
    this.defaultPrice = Number(pnrData.totalFare)
    pnrData.segmentFares.forEach(item => {
      this.defaultPrice = item.fares.reduce((total, item2) => {
        return Number(total) + (item2.passengerType === 'INFANT' ? item2.passengerCount * (Number(item2.marketFare) + Number(item2.airportTax) + Number(item2.fuelTax) - Number(item2.agentFee) - Number(item2.spFee)) : 0)
      }, Number(this.defaultPrice))
    })
    pnrData.totalFare = this.defaultPrice
  },
  methods: {
    async handleSubmit () {
      const { pnrData } = this
      let flagList = []
      let data = {}
      data.offerId = this.pnrData.offerId
      data.pnrNo = this.pnrData.pnrNo
      data.offerItemIds = []
      pnrData.segmentFares.forEach((item, index) => {
        flagList[index] = false
        data.offerItemIds.push({
          'offerItemId': item.offerItemId,
          'offerServices': []
        })
        item.fares.forEach(item2 => {
          if (item2.passengerType === 'INFANT') {
            data.offerItemIds[index].offerServices.push({
              'offerServiceId': item2.offerItemServiceId
            })
          }
          if (item2.checked === true) {
            data.offerItemIds[index].offerServices.push({
              'offerServiceId': item2.offerItemServiceId
            })
            flagList[index] = true
          }
        })
      })
      const flag = flagList.includes(false)
      let flagArr = []
      let tipsArr = []
      flagList.forEach((item, index) => {
        if (item === false) {
          flagArr.push(index)
        }
      })
      if (flag) {
        const tripType = pnrData.tripType
        pnrData.segmentFares.forEach((item, index) => {
          flagArr.forEach(item2 => {
            if (item2 === index) {
              if (tripType === 'OW') {
                tipsArr.push(`请选择行程${item.segment.depCode} - ${item.segment.arrCode}运价`)
              } else if (tripType === 'MW') {
                tipsArr.push(`请选择${index === 0 ? '去程' : '返程'}${item.segment.depCode} - ${item.segment.arrCode}运价`)
              } else if (tripType === 'RT') {
                tipsArr.push(`请选择${Number(index) + 1}程${item.segment.depCode} - ${item.segment.arrCode}运价`)
              }
            }
          })
        })
        this.$message.error(tipsArr.join(', '))
        return true
      }
      data.passengers = []
      this.passengersData.forEach((psg, index) => {
        const item = {
          certNo: psg.certNo,
          name: psg.name
        }
        data.passengers.push(item)
      })
      this.loading = true
      try {
        const result = await pnrSubmit(data)
        this.loading = false
        // 跳转支付页
        const submitResult = {
          success: true,
          data: result
        }
        if (submitResult.success) {
          storage.setItem(`SUBMIT_RESULT`, submitResult, 0.5 * 3600000)
        }
        this.$router.push({ path: '/pay/v1/pay' })
        // let temp = document.createElement('form')
        // temp.action = '/pay/pay.html'
        // temp.method = 'post'
        // temp.style.display = 'none'
        // let args = {
        //   seckillId: result,
        //   _csrf: this.csrf
        // }
        // if (args) {
        //   for (let x in args) {
        //     let opt = document.createElement('input')
        //     opt.name = x
        //     opt.value = args[x]
        //     opt.type = 'hidden'
        //     temp.appendChild(opt)
        //   }
        // }
        // document.body.appendChild(temp)
        // temp.submit()
        // return temp
      } catch (e) {
        this.loading = false
        this.$message.error(e.message)
      }
    },
    handleChange (value, key, column) {
      const newData = [...this.passengersData]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target.certNo = value
        this.passengersData = newData
      }
    },
    edit (key) {
      const newData = [...this.passengersData]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target.editable = true
        // this.$set(this.passengersData, key - 1, target)
        this.passengersData = newData
      }
    },
    save (key) {
      const newData = [...this.passengersData]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        delete target.editable
        this.passengersData = newData
        this.cacheData = newData.map(item => ({ ...item }))
      }
    },
    cancel (key) {
      const newData = [...this.passengersData]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        Object.assign(target, this.cacheData.filter(item => key === item.key)[0])
        delete target.editable
        this.passengersData = newData
      }
    }
  }
}
</script>

<style lang="less" scoped>
#pnr-detail {
  .pnr-error {
    width: 100%;
    height: 220px;
    font-size: 14px;
    color: #fff;
    line-height: 24px;
    .ant-input {
      background: #000;
      color: #00ff00;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .pnr-error-text {
    padding: 10px 0;
    font-size: 14px;
    color: @primary-color;
    line-height: 24px;
    .pnr-error-item {
      text-indent: 3em;
      color: #808080;
    }
  }
  .pnr-table {
    margin-top: 10px;
  }
  .table-passengers {
    margin-top: 25px;
  }

  .editable-row-operations {
    a {
      padding: 0 5px;
    }
  }
  .pnr-submit {
    padding-top: 30px;
    text-align: center;
    .ant-btn {
      width: 120px;
    }
  }
}
</style>

<style lang="less">
#pnr-detail {
  .table-col1 {
    width: 10%;
  }
  .table-col2 {
    width: 20%;
  }
}

.pnr-ticket-table {
  padding-top: 40px;
  color: #808080;
  h5 {
    padding-left: 5px;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 32px;
    font-weight: bold;
    // span {
    //   font-weight: normal;
    //   font-size: 14px;
    //   padding-left: 20px;
    // }
  }
  .total-fare {
    padding-top: 15px;
    text-align: right;
    p {
      font-size: 15px;
      em {
        font-style: normal;
        font-weight: bold;
        font-size: 17px;
        color: @primary-color;
      }
    }
  }
}

.product-table tr.ant-table-row td .ant-radio.ant-radio-disabled{
  display: none;
}
</style>
